<template lang="pug">
.view-cron-tasks.content
  ui-navbar-panel(title="Задачи")

  p.p-4.is-size-6
    a.mr-4.has-text-dark(@click="filterJobs('wait')")
      b-tooltip(label="wait")
        | В ожидании: {{ stats.wait }}
    a.mr-4.has-text-dark(@click="filterJobs('process')")
      b-tooltip(label="process")
        | В работе: {{ stats.process }}
    a.mr-4.has-text-dark(@click="filterJobs('done')")
      b-tooltip(label="done")
        | Успешно: {{ stats.done }}
    a.mr-4.has-text-dark(@click="filterJobs('canceled')")
      b-tooltip(label="canceled")
        span(:class="stats.canceled > 0 ? 'has-text-danger' : ''")
          | Отменено: {{ stats.canceled }}
    a.mr-4.has-text-dark(@click="filterJobs('failed')")
      b-tooltip(label="failed")
        span(:class="stats.failed > 0 ? 'has-text-danger' : ''")
          | С ошибкой: {{ stats.failed }}
    a.mr-4.has-text-dark(@click="filterJobs()")
      | Всего: {{ stats.total }}
    router-link(:to="{ name: 'newCronTask' }")
      b-button.is-pulled-right(type="is-primary", icon-left="plus-circle") Новая задача

  b-table(
    v-if="serverJobs",
    :data="serverJobs.items",
    :loading="serverJobs.$state.loading",
    detail-key="id",
    default-sort="id",
    default-sort-direction="desc",
    :current-page="numericPage",
    :per-page="perPage",
    :total="totalServerJobs",
    backend-sorting,
    backend-pagination,
    paginated,
    pagination-simple,
    striped,
    @sort="tableSort",
    @page-change="tablePageRange"
  )
    template(slot="empty")
      section.section
        .content.has-text-grey.has-text-centered
          template(v-if="serverJobs.$state.loaded")
            p: b-icon(icon="emoticon-sad")
            p Задачи не найдены
    //- Row
    b-table-column(field="id", label="ID", width="1", nowrap, sortable, numeric v-slot="{row}")
      | {{ row.id }}

    b-table-column(field="status", label="Статус", sortable v-slot="{row}")
      span(:class="row.status==='canceled' || row.status==='failed' ? 'has-text-danger' : ''") {{ row.status }}

    b-table-column(field="command", label="Команда", sortable v-slot="{row}")
      | {{ row.command }}

    b-table-column(field="platform_name", label="Платформа", sortable v-slot="{row}")
      b-tooltip(:label="row.platform_name")
        | {{ row.shortPlatformName }}

    b-table-column(field="platform_id", label="Сервер", v-slot="{row}")
      | {{ row.server_name }}

    b-table-column(field="is_complex", label="Составная", sortable v-slot="{row}")
      | {{ row.is_complex ? ('Да, № ' + row.task_index) : 'Нет' }}

    b-table-column(field="priority", label="Приоритет", sortable v-slot="{row}")
      | {{ row.priority===1 ? 'обычный' : 'высокий' }}

    b-table-column(field="difficulty", label="Сложность", sortable v-slot="{row}")
      | {{ row.difficulty===1 ? 'обычная' : 'высокая' }}

    b-table-column(field="platform_job_id", label="JobId", sortable v-slot="{row}")
      b-tooltip(label="platform_job_id")
        | {{ row.platform_job_id }}

    b-table-column(field="process_start_at", label="Начало работы", sortable v-slot="{row}")
      b-tooltip(label="process_start_at")
        | {{ row.process_start_at | dateFormat }}

    b-table-column(field="process_end_at", label="Окончание работы", sortable v-slot="{row}")
      b-tooltip(label="process_end_at")
        | {{ row.process_end_at | dateFormat }}

    b-table-column(field="process_period", label="Время", v-slot="{row}")
      span(v-if="row.status==='done'") {{ row.process_period }}

    b-table-column(field="is_test", label="Тест", sortable v-slot="{row}")
      | {{ row.is_test ? 'Да' : 'Нет' }}

    b-table-column(field="created_at", label="Создана", sortable v-slot="{row}")
      | {{ row.created_at | dateFormat }}

    b-table-column(field="description", label="Подробности", v-slot="{row}")
      b-tooltip(v-if="row.created_by==='manual'", label="Задача создана вручную через Хелпдеск")
        b-icon.mr-3(icon="run", type="is-primary")
      | {{ row.fullDescription.substring(0, 20) + (row.fullDescription && row.fullDescription.length > 20 ? '...' : '') }}

    b-table-column(field="edit", label="", v-slot="{row}")
      router-link(:to="{ name: 'editCronTask', params: { id: row.id } }")
        b-icon(icon="pencil-outline", style="cursor: pointer;" size="is-small")

    b-table-column(field="delete", label="", v-slot="{row}")
      b-icon(icon="close", style="cursor: pointer;" size="is-small" @click.native="deleteServerJob(row.id)")
</template>

<script>
import ServerJob from '@/models/ServerJob';
import api from '@/api';

export default {
  name: 'view-cron-tasks',

  data: () => ({
    serverJobs: ServerJob.collection(),
    stats: [],
    totalServerJobs: 0,
    perPage: 50,
  }),

  computed: {
    query() {
      return {
        page: 1,
        sort: '-id',
        ...this.$route.query,
      };
    },

    numericPage() {
      return this.query.page > 0 ? Number.parseInt(this.query.page) : 0;
    },

    filter() {
      let filter = this.query && this.query.filter ? JSON.parse(this.query.filter) : {};
      return {
        ...filter,
      };
    },
  },

  watch: {
    query() {
      this.loadServerJobs();
    },
  },

  methods: {
    loadServerJobs() {
      this.serverJobs.$fetch({
        include: '',
        page: this.query.page,
        sort: this.query.sort,
        filter: this.filter,
        limit: this.perPage,
        scope: 'withPlatformServer',
      }).then(({ meta }) => {
        this.perPage = meta.per_page;
        this.totalServerJobs = meta.total;
      });
    },

    loadStatistics() {
      api
        .for('cron-server')
        .read('statistics')
        .then((response) => {
          this.stats = response;
        });
    },

    deleteServerJob(id) {
      this.serverJobs.$delete(id);
    },

    filterJobs(status) {
      this.setFilter('status', status);
    },

    setQueryParam(key, value) {
      let query = { ...this.$route.query };
      if (!(query[key] && query[key] === value)) {
        query[key] = value;
        this.$router.push({query});
      }
    },

    setFilter(field, value) {
      let filter = { ...this.filter };

      if (value || value === 0) {
        filter[field] = value;
      } else {
        delete filter[field];
      }

      this.setQueryParam('filter', JSON.stringify(filter));
    },

    tableSort(field, direction) {
      this.setQueryParam('sort', (direction === 'desc' ? '-' : '') + field);
    },

    tablePageRange(page) {
      this.setQueryParam('page', page);
    },
  },

  created() {
    this.loadStatistics();
    this.setQueryParam('filter', undefined);
  },
};
</script>
